import React from 'react';
import styled from '@emotion/styled';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import FacebookIcon from '@material-ui/icons/Facebook';

import CustomFacebookIcon from '../common/icons/social/Facebook';
import theme from '../../theme';

type SocialBarProps = {
  socialItems: SocialItem[];
  isHeader: boolean;
};

type SocialItem = {
  social_media_link: string;
  social_media_type: {
    social_media_name: string;
  };
};

type StyledProps = {
  isHeader: boolean;
};

const SocialMediaWrapper = styled.ul<StyledProps>`
  text-align: ${props => (props.isHeader ? 'left' : 'right')};
  text-align: right;
  white-space: nowrap;
  @media (max-width: ${theme.screenMdMax}) {
    text-align: center;
    margin-bottom: 32px;
  }
`;

const SocialMediaItem = styled.li<StyledProps>`
  display: inline-block;
  text-align: left;
  margin-right: 16px;
  border-radius: 50%;
  padding: ${props => (props.isHeader ? '0' : '4px 6px')};
  background-color: ${theme.colorsWhite};
  color: ${props => (props.isHeader ? theme.colorsPrimaryBlue : theme.colorsBlack)};

  & svg:not(:root) {
    vertical-align: text-bottom;
    font-size: ${props => (props.isHeader ? '20px' : '1.5rem')};
  }
`;

const SocialBarComponent = ({ socialItems, isHeader }: SocialBarProps) => {
  const handleClick = (link: string) => {
    window.location.href = link;
    return;
  };

  return (
    <SocialMediaWrapper isHeader={isHeader}>
      {socialItems.map(item => {
        return (
          <SocialMediaItem
            key={item.social_media_type.social_media_name}
            onClick={() => handleClick(item.social_media_link)}
            isHeader={isHeader}
          >
            {item.social_media_type.social_media_name === 'facebook' && !isHeader && <CustomFacebookIcon />}
            {item.social_media_type.social_media_name === 'facebook' && isHeader && <FacebookIcon />}
            {item.social_media_type.social_media_name === 'instagram' && <InstagramIcon />}
            {item.social_media_type.social_media_name === 'twitter' && <TwitterIcon />}
            {item.social_media_type.social_media_name === 'linkedin' && <LinkedInIcon />}
            {item.social_media_type.social_media_name === 'youtube' && <YouTubeIcon />}
          </SocialMediaItem>
        );
      })}
    </SocialMediaWrapper>
  );
};

export default SocialBarComponent;
